exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".reconcile .ant-card-body {\n  padding: 16px !important;\n}\n", ""]);

// exports
